import { DashboardCard } from "@dashboard/components/Card";
import { Box, Checkbox, Text } from "@saleor/macaw-ui-next";
import { useIntl } from "react-intl";

import { platformMessages } from "./messages";

interface PlatformAccessCardProps {
  dashboardAccess: boolean;
  opsAccess: boolean;
  portalAccess: boolean;
  disabled: boolean;
  error?: string;
  onChange: (name: "dashboardAccess" | "opsAccess" | "portalAccess", value: boolean) => void;
}

export const PlatformAccessCard = ({
  dashboardAccess,
  opsAccess,
  portalAccess,
  disabled,
  error,
  onChange,
}: PlatformAccessCardProps) => {
  const intl = useIntl();

  return (
    <DashboardCard>
      <DashboardCard.Header>
        <DashboardCard.Title>{intl.formatMessage(platformMessages.cardTitle)}</DashboardCard.Title>
      </DashboardCard.Header>
      <DashboardCard.Content>
        <Text as="p" size={3} marginBottom={4}>
          {intl.formatMessage(platformMessages.cardDescription)}
        </Text>
        <Box display="flex" flexDirection="column" gap={3}>
          <Checkbox
            data-test-id="platform-dashboard-checkbox"
            checked={dashboardAccess}
            disabled={disabled}
            onCheckedChange={value => onChange("dashboardAccess", !!value)}
          >
            <Text>{intl.formatMessage(platformMessages.dashboardOption)}</Text>
          </Checkbox>
          <Checkbox
            data-test-id="platform-ops-checkbox"
            checked={opsAccess}
            disabled={disabled}
            onCheckedChange={value => onChange("opsAccess", !!value)}
          >
            <Text>{intl.formatMessage(platformMessages.opsOption)}</Text>
          </Checkbox>
          <Checkbox
            data-test-id="platform-portal-checkbox"
            checked={portalAccess}
            disabled={disabled}
            onCheckedChange={value => onChange("portalAccess", !!value)}
          >
            <Text>{intl.formatMessage(platformMessages.portalOption)}</Text>
          </Checkbox>
        </Box>
        {error && (
          <Text as="p" size={2} color="critical1" marginTop={3}>
            {error}
          </Text>
        )}
      </DashboardCard.Content>
    </DashboardCard>
  );
};
